import cn from "classnames";
import { bidPointLoadUnloadStatuses, bidStatuses } from "helpers/enums";
import { enumLabel } from "helpers/system";
import ArrowRight from "icons/planning/arrow-right.svg";
import React from "react";

export default function Route(props) {
    const { data } = props;
    const { plannedEndDate, estimatedEndDate, from, to, isEmptyMileageBid } = data;
    if (!from || !to) {
        return isEmptyMileageBid ? (
            <span className="badge badge-brand" data-test-id="trip-planning-empty-mileage-bid">
                Порожняя заявка
            </span>
        ) : null;
    }

    const isLate = new Date(plannedEndDate).getTime() < new Date(estimatedEndDate).getTime();
    const lineWidth = (data.visitedPointCount / data.totalPointCount) * 100;

    return (
        <div className="w-100">
            <div className="d-inline-flex w-100">
                <div className="flex-grow-1 overflow-hidden pr-3">
                    <div className="ellipsis" data-test-id="trip-planning-route-from">
                        {from.city}
                        <ArrowRight className="pl-1" />
                    </div>
                    <div className="ellipsis font-weight-semibold" data-test-id="trip-planning-route-to">
                        {to.city}
                    </div>
                    <div className="p-route__line-wrap">
                        <div className="p-route__line" />
                        <div
                            className={cn("p-route__line", {
                                "p-route__line--green": !isLate,
                                "p-route__line--red": isLate,
                            })}
                            style={{ width: `${lineWidth}%` }}
                        />
                    </div>
                </div>
                <div className="p-route__status">
                    {isEmptyMileageBid && (
                        <div className="text-right mb-1">
                            <span className="badge badge-primary" data-test-id="trip-planning-empty-mileage-bid">
                                Порожняя заявка
                            </span>
                        </div>
                    )}
                    <div className="text-right" data-test-id="trip-planning-bid-status">
                        {enumLabel(bidStatuses, data.bidStatus)}
                    </div>
                    {data.bidPointLoadUnloadStatus && (
                        <div className="text-right" data-test-id="trip-planning-load-unload-status">
                            {enumLabel(bidPointLoadUnloadStatuses, data.bidPointLoadUnloadStatus)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
